/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcResponsiveTable
 * @scope
 * @require ngModel
 * @param {json} data This is a json string data which will be supplied to the datatable
 * @param {string} rowKey This string value holds the row key details
 * @param {object=} ngModel The model from which he data is supplied to the datatable
 * @param {Integer=} resultsPerPage This integer value holds the number of results per page for the datatable
 * @param {object=} columnData This object holds the column data for the datatable.
 * @param {Integer=} selectResultsPerPage The integer value that holds the number.
 * @description
 * The wcResponsiveTable directive adds responsive behavior to jquery datatable. With this directive in use, the
 * datatable will adjust automatically according to the window size.
 */



angular.module('WcResponsiveTableModule').directive('wcResponsiveTable', ['$compile', '_', '$timeout', '$swipe', 'WcTableScopeService', 'WcTableCollectionService', 'WcTablePaginationService', 'WcColumnFilterService',
	function ($compile, _, $timeout, $swipe, WcTableScopeService, WcTableCollectionService, WcTablePaginationService, WcColumnFilterService) {
		return {
			require: ['wcResponsiveTable', '?ngModel'],
			scope: {},
			bindToController: {
				data: '&',
				rowKey: '@',
				//bind between our ngModel and our interal selectedRows
				//selectedRows: '=ngModel',
				ngModel: '=?',
				resultsPerPage: '=',
				paginationControlsPlacement: '@',
				responsiveView: '@',
				columnData: '=',
				selectResultsPerPage: '=',
				required: '@',
				paginationEnabled: '@',
				checkallnoneEnabled: '@',
				exporttopdfEnabled: '@',
				exporttoexcelEnabled: '@'
			},
			controllerAs: 'responsiveTableController',
			controller: ['$scope', '$element', '$attrs', 'WcTranslateConfiguratorService', '$translate', function ($scope, $element, $attrs, WcTranslateConfiguratorService, $translate) {
                WcTranslateConfiguratorService.loadPartAndRefresh('WC-dataTable');

				var parentScope = $scope.$parent;

				this.id = $attrs.id;
				this.element = $element;

				this.WcTableScopeService = new WcTableScopeService();
				this.WcTableScopeService.setParentScope(parentScope);
				this.WcTableScopeService.setTableScope($scope);

				this.WcTableCollectionService = new WcTableCollectionService(this.WcTableScopeService);
				this.WcTableCollectionService.setInitialCollection(this.data());
				this.WcTableCollectionService.setRowKey(this.rowKey);

				this.WcTablePaginationService = new WcTablePaginationService(this.WcTableCollectionService);

				this.WcColumnFilterService = new WcColumnFilterService();

				var ngModelController = $element.controller('ngModel');

				//workaround for directive attributes that we don't want to set equal to true
				if (this.required === "") {
					this.required = true;
				}

				if (this.paginationEnabled === "") {
					this.paginationEnabled = true;
				}

				if (this.checkallnoneEnabled === "") {
					this.checkallnoneEnabled = true;
				}
				if (this.exporttopdfEnabled === "") {
					this.exporttopdfEnabled = true;
				}

				if (this.exporttoexcelEnabled === "") {
					this.exporttoexcelEnabled = true;
				}

                if(!this.ngModel) {
                    this.ngModel = [];
                }

                //TODO: Determine if this variable is used
				this.lastCollectionRendered = null;
				$scope.renderTable = function (resetToPageOne) {
					$scope.$broadcast('table.pagination.update', resetToPageOne);
					$scope.$broadcast('table.render.start');
					$scope.tableIsLoading();
				};

				$scope.tableIsLoading = function () {
					$('.wc-table-loading-indicator').show();
					$('.wc-table-loading-cover').show();
				};

				$scope.tableIsFinishedLoading = function () {
					$('.wc-table-loading-indicator').hide();
					$('.wc-table-loading-cover').hide();
				};

				$scope.tableRendered = function () {
					$('.wc-table-column-' + this.previousSortColumn).removeClass('wc-table-column-highlight');
					$('.wc-table-column-' + this.activeSortColumn).addClass('wc-table-column-highlight');

					$timeout(angular.bind(this, function () {
						parentScope.$broadcast('table.render.complete');
						//$scope.$digest();
						$scope.tableIsFinishedLoading();
					}), 0);
				};

				//TODO: Update these sections later
                this.selectedMathFilterOption = [];
				this.toggleFilterVisibility = function () {

                    var currentText = this.element.find('.filter-visibility-toggle span:first-child').text();

					this.element.find('thead input[wc-column-filter], thead select[wc-column-filter], thead select[id^="wc-math-filter"]').toggle();

					if (!this.staticFilter) {
                        var showFilterLabel = $translate.instant('columnFilter.showFilters');
                        var hideFilterLabel = $translate.instant('columnFilter.hideFilters');

                        currentText = currentText===showFilterLabel?  hideFilterLabel : showFilterLabel;

						this.element.find('.filter-visibility-toggle span:first-child').text(currentText);
					}
				};

				this.setupRachetingColumns = function () {
					//should match index for the first column of data
					var ratchetIndex = 2;
					this.ratchetCols = function(direction) {
						//only ratchet at mobile or tablet sizes
						if(window.innerWidth < 1200) {
							$scope.$broadcast('ng-swipe');
							if(direction == 'left') {
								$('#' + this.id + '.table-ratchet .wc-table-column-'+ratchetIndex).hide();
								if(ratchetIndex < this.numberOfCols) {
									ratchetIndex++;
								}
							}
							else if(direction == 'right') {
								$('#' + this.id + '.table-ratchet .wc-table-column-'+(ratchetIndex-1)).show();
								if(ratchetIndex > 2) {
									ratchetIndex--;
								}
							}
						}
					};

					$scope.$on('ng-swipe', angular.bind(this, function(event, args) {
						if (!this.animating) {
							this.animating = true;
							// pulse effect animation
							$('#' + this.id + '.table-ratchet table').animate({
								opacity : 0.70
							}, 150, angular.bind(this, function() {
								$('#' + this.id + '.table-ratchet table').animate({
									opacity : 1
								}, 200, function() {
								});
							}));
							this.animating = false;
						}
					}));
				};

				this.setupPaginationDefaults = function () {
					if (this.paginationEnabled || this.resultsPerPage ||
						this.numberOfPageControls || this.selectResultsPerPage ||
						this.responsiveBreakpoints || this.paginationControlsPlacement) {

						this.WcTablePaginationService.setPaginationState(true);

						this.WcTablePaginationService.setPaginationDefaults({
							numberOfPageControls: this.numberOfPageControls,
							responsiveBreakpoints: this.responsiveBreakpoints,
							selectResultsPerPage: this.selectResultsPerPage,
							resultsPerPage: this.resultsPerPage,
							paginationControlsPlacement: this.paginationControlsPlacement
						});
					}
				};

				this.setupTableValidation = function() {
					this.ngModel = this.ngModel || [];

					if(ngModelController) {
						ngModelController.$name = 'wcResponsiveTable';

						//convert $viewValue to $modelValue
						//$viewValue is passed in, modify it and return what will be applied to $modelValue
						ngModelController.$parsers.push(angular.bind(this, function (viewValue) {
							//add validation here for required fields
							if (this.required) {
								if (!viewValue || (angular.isArray(viewValue) && viewValue.length === 0)) {
									ngModelController.$setValidity('tableRequired', false);
								}
								else {
									ngModelController.$setValidity('tableRequired', true);
								}
							}
							return viewValue;
						}));

						//convert $modelValue to $viewValue
						//$modelValue is passed in, modify it and return what will be applied to $viewValue
						ngModelController.$formatters.push(angular.bind(this, function (modelValue) {
							//add validation here for required fields
							if (this.required) {
								if (!modelValue || (angular.isArray(modelValue) && modelValue.length === 0)) {
									ngModelController.$setValidity('tableRequired', false);
								}
								else {
									ngModelController.$setValidity('tableRequired', true);
								}
							}
							return modelValue;
						}));

						//function to call when $viewValue should be updated with a new value after a user interaction
						this.applyModel = function (value) {
							ngModelController.$setViewValue(value);
						};

						//register this table with the form obj
						ngModelController.$$parentForm.$addControl(ngModelController);
					}
				};
			}],
			link: function (scope, element, attrs, controllers) {

				var responsiveTableController = controllers[0];
				var ngModelController = controllers[1];

				this.preSetupTable = function () {
					// jshint unused:true
					var table = element[0].children[0];
					if (table.tagName !== 'TABLE') {
						// console.error('Table tag <table> must come right after <wc-responsive-table>');
						// console.error('Directive found ' + table[0].tagName + ' instead');
						throw 'Is this an equivalent error message';
					}

					element.addClass('wc-table');

					var dataRow = $(table).find('tbody tr');
					var headerRow = $(table).find('thead tr')[0];

					responsiveTableController.numberOfCols = headerRow.children.length;

					responsiveTableController.columnsToHide = [];
					for (var i = 0; i < headerRow.children.length; i++) {
						responsiveTableController.columnsToHide[i] = false;
						$(headerRow.children[i])
                            .addClass('wc-table-column-' + i);

                        var headerTxtNode = $(headerRow.children[i]).contents().filter(function(){ return this.nodeType === 3 && $.trim(this.nodeValue) !== '' ; });
                        var headerTxtPreWrap = $(headerRow.children[i]).children()[0];

                        if(headerTxtNode.length>0) {
                            $(headerTxtNode).wrap("<div class='header-text-wrapper'><span class='header-text'></span></div>");
                        }
                        else {
                            $(headerTxtPreWrap).wrap("<div class='header-text-wrapper'></div>").addClass('header-text');
                        }

                        if($(headerRow.children[i]).find('[wc-column-filter]').length>0&&$(headerRow.children[i]).find('.form-group').length<1) {
                            $('.wc-table-column-'+ i+' .header-text-wrapper').after("<div class='form-group'></div>");
                            if($(headerRow.children[i]).find('[wc-math-filter]').length>0) {
                                $(headerRow.children[i]).find('label, .wc-math-filter-row').appendTo('.wc-table-column-'+ i+' .form-group');
                            }
                            else {
                                $(headerRow.children[i]).find('label, input, select').appendTo('.wc-table-column-' + i+' .form-group');
                            }

                        }
						//.attr('column-index', i);

                        //if (responsiveTableController.responsiveView === 'list') {
                        var columnHeading = $(headerRow.children[i]);
                        var columnHeadingText = headerTxtNode[0] ? headerTxtNode[0].nodeValue : '';
                        $(dataRow.children()[i]).attr('data-title', columnHeadingText);
                        console.log('columnHeading', $(dataRow.children()[i]), columnHeadingText);
                        //}
					}

					for (i = 0; i < dataRow.children().length; i++) {
						var item = $(dataRow.children()[i]);

						item.addClass('wc-table-column-' + i);
						//.attr('column-index', i);



					}

					responsiveTableController.setupTableValidation();

					var tableConfig = {
						table: table,
						dataRow: dataRow,
						headerRow: headerRow
					};

					responsiveTableController.table = $(table);

					return tableConfig;
				};

				this.addLoadingIndicator = function () {
					var loadingElement = '<div class="wc-table-loading-cover"><div class="wc-table-loading-indicator"><span>{{"loading" | translate}}</span></div>';

					element.append($compile(loadingElement)(scope));
				};

				this.addColumnFilteringFeature = function (tableConfig) {
					if (element.find('thead input[wc-column-filter], thead select[wc-column-filter]').length) {
						if (attrs.staticFilter === "") {
							responsiveTableController.staticFilter = true;
							responsiveTableController.toggleFilterVisibility();
						}
						else {
							var filterToggle = '<div class="filter-visibility-toggle" ng-click="responsiveTableController.toggleFilterVisibility()"><span>{{"columnFilter.showFilters" | translate}}</span><span class="glyphicon glyphicon-filter"></span></div>';
                            $(tableConfig.table).before('<div class="active-filters hidden"></div>');
							$(tableConfig.table).before($compile(filterToggle)(scope));

						}
					}
				};
				responsiveTableController.toggleFilterVisibility();

				this.addPaginationFeature = function (tableConfig) {
					if (responsiveTableController.paginationEnabled) {
						responsiveTableController.setupPaginationDefaults();
						$(tableConfig.table).before($compile('<wc-table-pagination>')(scope));
					}
				};

				this.addCheckAllNoneFeature = function (tableConfig) {
					if(responsiveTableController.checkallnoneEnabled) {
						var checkAllNone = $compile('<wc-check-all-none target-container-id="' + attrs.id + '">')(scope);
						$(tableConfig.table).next().after(checkAllNone);
					}
				};

				this.addExportToPdfFeature = function () {
					if(responsiveTableController.exporttopdfEnabled) {
						var tableButtonGroup = element.find('.wc-table-buttons');
						if(tableButtonGroup.length > 0) {
							tableButtonGroup.append($compile('<wc-export-to-pdf>')(scope));
						} else {
							var template = angular.element('<div class="btn-group wc-table-buttons pull-right"><wc-export-to-pdf/></div>');
							element.prepend($compile(template)(scope));
						}
					}
				};

				this.addExportToExcelFeature = function () {
					if (responsiveTableController.exporttoexcelEnabled){
						var tableButtonGroup = element.find('.wc-table-buttons');
						if(tableButtonGroup.length > 0) {
							tableButtonGroup.append($compile('<wc-export-to-excel>')(scope));
						} else {
							var template = angular.element('<div class="btn-group wc-table-buttons pull-right"><wc-export-to-excel/></div>');
							element.prepend($compile(template)(scope));
						}
					}
				};

				this.addResponsiveFeature = function () {
					switch(responsiveTableController.responsiveView) {
						case 'scroll': {
							this.addScrollingTableFeature();
							break;
						}
						case 'ratchet': {
							responsiveTableController.setupRachetingColumns();
							this.addRachetingColumnsFeature(tableConfig);
							break;
						}
						case 'column-toggle': {
							this.addColumnToggleFeature(tableConfig);
							break;
						}
						case 'radio-columns': {
							this.addColumnToggleFeature(tableConfig);
							break;
						}
						case 'list': {
							this.addListViewFeature();
							break;
						}
						case 'drop': {
							//support dropping cols here eventually
							break;
						}
						default: {
							this.addScrollingTableFeature();
							break;
						}
					}
				};

				this.addScrollingTableFeature = function() {
					element.addClass('table-responsive');

					var setMatchingHeights = function(selector) {
						$(selector).each(function(index, item){
							$(item).css('height', $(item).closest('tr').css('height'));
						});
					};

					var columnResizeHandler = function(){
						setMatchingHeights('#' + responsiveTableController.id + ' .wc-table-column-0');
						setMatchingHeights('#' + responsiveTableController.id + ' .wc-table-column-1');
					};

					$(window).on('resize', _.debounce(columnResizeHandler,250));
					scope.$on('table.render.complete', _.debounce(columnResizeHandler,10));

					var scrollHandler = function(event){
						$('#' + responsiveTableController.id + ' .wc-table-column-0').each(function(index, item){
							$(item).css('left', event.currentTarget.scrollLeft + "px");
						});
						$('#' + responsiveTableController.id + ' .wc-table-column-1').each(function(index, item){
							$(item).css('left', (event.currentTarget.scrollLeft + 100) + "px");
						});
						$('#' + responsiveTableController.id + ' .filter-visibility-toggle').each(function(index, item){
							$(item).css('left', (event.currentTarget.scrollLeft + 15) + "px");
						});
					};

					element.scroll(scrollHandler);
					element.on('touchmove', scrollHandler);
				};

				this.addRachetingColumnsFeature = function(tableConfig) {
					element.addClass('table-ratchet');

					// The maximum vertical delta for a swipe should be less than 75px.
					//start block of modified code coming from angular-touch library.
					var MAX_VERTICAL_DISTANCE = 75;
					// Vertical distance should not be more than a fraction of the horizontal distance.
					var MAX_VERTICAL_RATIO = 0.3;
					// At least a 30px lateral motion is necessary for a swipe.
					var MIN_HORIZONTAL_DISTANCE = 30;

					var startCoords, valid;

					var directionOfSwipe = function(coords) {
						// Check that it's within the coordinates.
						// Absolute vertical distance must be within tolerances.
						// Horizontal distance, we take the current X - the starting X.
						// This is negative for leftward swipes and positive for rightward swipes.
						// After multiplying by the direction (-1 for left, +1 for right), legal swipes
						// (ie. same direction as the directive wants) will have a positive delta and
						// illegal ones a negative delta.
						// Therefore this delta must be positive, and larger than the minimum.
						if (!startCoords) {
							return false;
						}
						var deltaY = Math.abs(coords.y - startCoords.y);
						var deltaX = coords.x - startCoords.x;
						if(valid && // Short circuit for already-invalidated swipes.
							deltaY < MAX_VERTICAL_DISTANCE &&
							deltaX !== 0 &&
							Math.abs(deltaX) > MIN_HORIZONTAL_DISTANCE &&
							deltaY / Math.abs(deltaX) < MAX_VERTICAL_RATIO) {
							return (deltaX > 0) ? 'right' : 'left';
						}
						else {
							return false;
						}
					};

					$swipe.bind($(tableConfig.table), {
						'start': function(coords) {
							startCoords = coords;
							valid = true;
						},
						'cancel': function() {
							valid = false;
						},
						'end': function(coords) {
							var direction = directionOfSwipe(coords);
							if (direction) {
								responsiveTableController.ratchetCols(direction);
							}
						}
					});

					//end block of angular-touch code

					//add indicator bar(s) to show ratcheting is available?
					var ratchetBar = '<div class="ratchet-indicator"><span>...</span></div>';
					$(tableConfig.table).after(ratchetBar);
				};

				this.addColumnToggleFeature = function(tableConfig) {
					element.addClass('column-toggle');
					//add controls to allow the user to hide columns

					var columnToggle = '<span class="dropdown column-toggle">' +
						'<span name="columnToggleDropdown" data-toggle="dropdown" id="'+responsiveTableController.id+'-columnToggleDropdown">' +
						'<span>{{"manageColumns" | translate}}</span><span class="glyphicon glyphicon-chevron-down"></span>' +
						'</span>' +
						'<fieldset class="dropdown-menu form-group" role="menu" aria-labelledby="'+responsiveTableController.id+'-columnToggleDropdown">';

					$(tableConfig.headerRow).children().each(function(index, item) {
						var columnName =$(item).find('.header-text').text();

						if(item.firstChild.nextSibling && item.firstChild.nextSibling.localName == 'wc-row-select-header-checkbox')
						{
							columnName='Checkbox Column' ;
						}
						if(item.firstChild.nextSibling && item.firstChild.nextSibling.localName == 'wc-row-select-header-radio')
						{
							columnName='Radio Column' ;
						}

						if( item.firstChild !== null )
						{
							columnToggle += '<div role="menuitem" class="checkbox">' +
								'<label for="col' + index + '">' +
								'<input id="col' + index + '" type="checkbox" checked ng-model="responsiveTableController.columnsToHide['+index+']"/>' + columnName +
								'</label></div>';
						}
					});
					columnToggle += '</fieldset></span>';

					scope.$watchCollection(function(){
							return responsiveTableController.columnsToHide;
						}, function(newValue, oldValue) {
							if(newValue !== oldValue) {
								for(var i=0; i<newValue.length; i++) {
									if(!newValue[i]) {
										$('#'+responsiveTableController.id+'.column-toggle .wc-table-column-'+i).hide();
									}
									else {
										$('#'+responsiveTableController.id+'.column-toggle .wc-table-column-'+i).show();
									}
								}
							} else {
								for (var i=0; i<newValue.length; i++) {
									newValue[i] = true;
								}
								$('#'+responsiveTableController.id+'.column-toggle .form-group').click(function(e){
									e.stopPropagation();
								});
							}
						}
					);
					$(tableConfig.table).before($compile(columnToggle)(scope));
                };

				this.addListViewFeature = function() {
					element.addClass('table-mobile-stack');
				};

				this.postSetupTable = function (tableConfig) {
					var dataRow = tableConfig.dataRow;

					//$compile(headerRow)(scope);

					responsiveTableController.dataRowChildren = dataRow.children().clone();
					dataRow.children().remove();

					dataRow.attr('wc-row-repeat', '');
					$compile(dataRow)(scope);

					if (dataRow[0].children.length < 1) {
						scope.renderTable();
					}
				};


				/**
				 * Load the table and features
				 */
				var tableConfig = this.preSetupTable();

				this.addLoadingIndicator();

				this.addColumnFilteringFeature(tableConfig);

				this.addPaginationFeature(tableConfig);

				this.addCheckAllNoneFeature(tableConfig);

				this.addExportToPdfFeature();

				this.addExportToExcelFeature();

				this.addResponsiveFeature(tableConfig);

				this.postSetupTable(tableConfig);
			}
		};
	}]);
